const isOdd = x => Boolean(x % 2);

const elementClick = new MouseEvent('click', {
  view: window,
  bubbles: true,
  cancelable: false,
});

export { isOdd, elementClick };
